import { createContext, useContext, useMemo, useState } from 'react';

const LoadedFontsContext = createContext<{
  fontFamiliesLoaded: string[];
  addFontFamiliesLoaded: (fontFamilies: string[]) => void;
}>({
  fontFamiliesLoaded: [],
  addFontFamiliesLoaded: () => {}, // eslint-disable-line @typescript-eslint/no-empty-function
});

export const LoadedFontsContextProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [fontFamiliesLoaded, setFontFamiliesLoaded] = useState<string[]>([]);

  return (
    <LoadedFontsContext.Provider
      value={useMemo(
        () => ({
          fontFamiliesLoaded,
          addFontFamiliesLoaded: newlyFontFamiliesLoaded =>
            setFontFamiliesLoaded([...fontFamiliesLoaded, ...newlyFontFamiliesLoaded]),
        }),
        [fontFamiliesLoaded, setFontFamiliesLoaded],
      )}
    >
      {children}
    </LoadedFontsContext.Provider>
  );
};

export const useLoadedFonts = () => useContext(LoadedFontsContext);
